
//var excelTableStats;

//function InitStats(arg) {

   

//    excelTableDashboard = jexcel(document.getElementById('spreadsheetstats'), {
//        data: null,
//        minDimensions: [2, 1],
//        tableOverflow: true,
//        columns: [
//            {
//                title: 'Total visitors',
//                type: 'string',
//                width: '200px',
//            },
//            {
//                title: 'Visitors this month',
//                type: 'string',
//                width: '200px',
//            },
//            {
//                title: 'Visitors this week',
//                type: 'number',
//                width: '150px',
//            },
//            {
//                title: 'Visitors today',
//                type: 'number',
//                width: '150px',
//            },
//            //{
//            //    title: 'Most visitors from company',
//            //    type: 'string',
//            //    width: '200px',
//            //},
//            {
//                title: 'Average visit time [min]',
//                type: 'string',
//                width: '220px',
//            },

//        ],
//        rowResize: true,
//        columnDrag: true,
//    });
//}

//function setStatsData(arg) {
//    var data1 = [];

//    console.log(arg);

//    var averageVisitTime = '-';

//    try {
//        if (arg.averageVisitTime > 0) {
//            averageVisitTime = arg.averageVisitTime;
//        }

//    } catch (e) {

//    }

//    var row = [arg.totalVisitors, arg.visitorsThisMonth, arg.visitorsThisWeek, arg.visitorsToday, averageVisitTime];
//    data1.push(row);

//    if (excelTableDashboard != null) {
//        excelTableDashboard.setData(data1, false);
//    }
    
//}


// Busy hours graph



var chartColors = {
    red: 'rgb(255, 99, 132)',
    orange: 'rgb(255, 159, 64)',
    yellow: 'rgb(255, 205, 86)',
    green: 'rgb(75, 192, 192)',
   // blue: '#1b6ec2', // 'rgb(54, 162, 235)',
    blue: 'rgb(75, 192, 192)', // 'rgb(54, 162, 235)',
    purple: 'rgb(153, 102, 255)',
    grey: 'rgb(201, 203, 207)'
};


function buildBusyHoursGraph(busyHoursData) {

    console.log(busyHoursData);

    var dataArray = []
    var labelArray = [];
    for (var i = 0; i < 24; i++) {
        dataArray.push(busyHoursData[i].busyHoursCountDistribution);

        labelArray.push(i.toString());
    }

    console.log("Building graph");

    console.log(dataArray);


	var barChartData = {
		labels: labelArray,
		datasets: [{
			label: 'Visitors in hour (%)',
            backgroundColor: '#1b6ec2',
            borderColor: chartColors.blue,
			borderWidth: 1,
            data: dataArray
		}]
	};
		var ctx = document.getElementById('busyHoursCanvas').getContext('2d');
		window.myBar = new Chart(ctx, {
			type: 'bar',
			data: barChartData,
			options: {
				responsive: true,
				legend: {
					position: 'top',
				},
				title: {
					display: true,
					text: 'Busy hours'
                },
                scales: {
                    xAxes: [{
                        gridLines: {
                            display: false
                        },
                        scaleLabel: {
                            display: true,
                            labelString: 'Hour of day'
                        }
                    }],
                    yAxes: [{
                        gridLines: {
                            display: false
                        },
                        scaleLabel: {
                            display: false,
                            labelString: 'Percent'
                        },
                        ticks: {
                            display: false
                        }
                    }]
                }
			}
		});

	

}